import { Typography, WithStyles, withStyles } from "@material-ui/core";
import * as React from "react";

import { styles } from "./StatisticsElement.style";

interface StatisticElementProps {
    month?: string;
    count?: number;
}
class StatisticElement extends React.Component<StatisticElementProps & WithStyles<typeof styles>> {
    public render() {
        const { classes, month, count } = this.props;

        return (
            <div className={classes.container}>
                <Typography variant="subheading">{month}</Typography>
                <Typography className={classes.number} variant="display1">
                    {count}
                </Typography>
                <Typography variant="subheading" style={{ fontWeight: 300 }}>
                    {count === 1 ? "Proposition" : "Propositions"}
                </Typography>
            </div>
        );
    }
}

export default withStyles(styles)(StatisticElement);



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticElement.tsx